import styled from 'styled-components';

export const TabContainer = styled.div`
  background: #fff;
  border-bottom: 1px solid rgb(0 0 0 / 6%);
`;

export const CohortWrapper = styled.div`
  display: block;
  margin: 8px;
`;

export const CohortHeader = styled.div`
  background: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CohortHeaderTitle = styled.div`
  font-size: 20px;
  color: rgb(0 0 0 / 85%);
`;

export const MainContainer = styled.div`
  display: flex;
  margin-top: 8px;
  background: #fff;
  min-height: calc(100vh - 120px);
`;

export const CustomDimensionInfo = styled.span`
  font-size: 14px;
`;
